<template>
  <div class="Site PageBox">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('Finance[8]')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
      <van-list
        v-model="isLoad"
        :finished="isFinished"
        :finished-text="listData.length?$t('vanPull[0]'):$t('vanPull[1]')"
        :class="{Empty:!listData.length}"
        @load="onLoad"
      >
        <div v-for="item,index in listData" :key="index" class="order-item">
          <div class="title">
            <h4>{{item.title}}</h4>
            <i>{{InitData.currency}}{{Number(item.money)}}</i>
          </div>
          <div class="info">
            <div class="flex">
              <p>{{$t('Finance[6][2]')}}</p><span>{{InitData.currency}}{{Number(item.daily_dividend)}}</span>
            </div>
            <div class="flex">
              <p>{{$t('Finance[6][3]')}}</p><span>{{item.day}}{{$t('Finance[6][4]')}}</span>
            </div>
            <div class="flex">
              <p>{{$t('Finance[6][5]')}}</p><span>{{Number(item.number)}}</span>
            </div>
          </div>
          <div class="bottom">
            <span :class="{active:item.state==1}">{{item.state_dec}}</span>
            <div class="btn">
              <van-button v-if="item.state==1" round type="danger" size="mini" @click="transferOut(item.id,'income')">{{$t('Finance[9][0]')}}</van-button>
              <van-button v-if="item.state==1" round type="primary" size="mini" @click="transferOut(item.id,'all')">{{$t('Finance[9][1]')}}</van-button>
              <van-button round type="info" size="mini" @click="$router.push(`/financeOrder/${item.id}`)">{{$t('Finance[9][2]')}}</van-button>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinanceOrder',
  components: {

  },
  props: [],
  data() {
    return {
      listData: '',
      isLoad: false,
      isFinished: false,
      pageNo: 1,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getListData()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    onLoad() {
      this.getListData('load')
    },
    getListData(type) {
      this.isLoad = true
      if(type=='load'){
        this.pageNo+=1
      }else{
        this.pageNo = 1
        this.isFinished = false
      }
      this.$Model.GetFinanceOrder({page_no: this.pageNo},data=>{
        this.isLoad = false
        if(data.code==1){
          if(type=='load'){
            this.listData = this.listData.concat(data.info)
          }else{
            this.listData = data.info
          }
          if(this.pageNo==data.data_total_page){
            this.isFinished = true
          }else{
            this.isFinished = false
          }
        }else{
          this.listData = ''
          this.isFinished = true
        }
      })
    },
    transferOut(id,type) {
      let msg = this.$t('Finance[10][0]')
      if(type=='all'){
        msg = this.$t('Finance[10][1]')
      }
      this.$Dialog.Confirm(msg,()=>{
        this.$Model.OutFinanceOrder({orderId: id, outType: type},data=>{
          if(data.code==1){
            this.getListData()
          }
        })
      })
    },
  }
}
</script>
<style scoped>
.order-item{
  background-color: var(--background-main);
  margin: 12px;
  border-radius: 10px;
  padding: 15px 10px;
  line-height: 1;
}
.order-item .title{
  display: flex;
  align-items: flex-end;
}
.order-item .title h4{
  flex: 1;
  margin-right: 15px;
  font-size: 15px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order-item .title i{
  color: var(--color-assist);
}
.order-item .info{
  display: flex;
  margin-top: 12px;
  justify-content: space-between;
}
.order-item .info .flex{
  text-align: center;
}
.order-item .info .flex p{
  color: var(--color-assist);
  font-size: 12px;
  margin-bottom: 5px;
}
.order-item .bottom{
  display: flex;
  align-items: center;
  border-top: 1px solid var(--border-color-main);
  margin-top: 12px;
  padding-top: 10px;
}
.order-item .bottom>span{
  color: var(--color-assist);
}
.order-item .bottom .active{
  color: var(--color-active);
}
.order-item .bottom .btn{
  flex: 1;
  text-align: right;
}
</style>